import {IntermediatePart} from "../../intermediatePart";
import {PLACEMENTS} from "../../constants";

export default class Stovetop extends IntermediatePart {
  constructor(isChild) {
    super(isChild);
    this.partId = 'center_island_stovetop';
    this.partName = 'Stovetop';
    this.translateId = "visualizer.kitchen.center_island.center_island_stovetop";
    this.canBeDisabled = true;
    this.defaultDisabled = true;
    this.disabled = true;
  }

  load(dbFeature) {
    if (dbFeature.metaData && dbFeature.metaData["Placement"]
      && !dbFeature.metaData["Placement"].includes(PLACEMENTS.Island)) {
      return false
    }
    dbFeature.metaData["RoomLayout"] = (dbFeature.metaData["RoomLayout"] && dbFeature.metaData["RoomLayout"].filter(roomLayout => roomLayout.includes("I"))) || [];
    return super.load_(dbFeature, new Stovetop());
  }

  disabledClick() {
    const centerIslandParent = this.getParent();
    const cabinet = centerIslandParent.cabinet;

    if (!cabinet.featureGroupEnabled) {
      super.hideLayers();
      return
    }

    if (!this.disabled && cabinet.disabled) {
      cabinet.disabled = false;
      cabinet.disabledClick();
    }
    const sink = centerIslandParent.sink;
    const range = centerIslandParent.range;
    if (sink && !this.disabled && !sink.disabled) {
      sink.disabled = true;
      sink.disabledClick();
    }
    if (range && !this.disabled && !range.disabled) {
      range.disabled = true;
    }
  }

  setLayers(layout) {

    const centerIslandParent = this.getParent();
    const sink = centerIslandParent.sink;
    const range = centerIslandParent.range;
    if ((sink && !sink.disabled) || (sink && !range.disabled)) {
      super.hideLayers();
      return
    }

    if (this.activeFeature && (this.activeFeature.matchesMetaForArrayOfConditions(this.getArrayOfConditions())
      || (this.activeFeature.notAvailableInVisualizer && this.placeholderFeature))) {
      super.setLayers(layout);
    } else {
      this.setDefault();
      super.setLayers(layout);
    }
  }

  getArrayOfConditions() {
    return [{
      propName: 'RoomLayout',
      propValue: this.getParent().layout.getCurrentLayoutAbbreviation()
    }];
  }

  setZIndex(zIndexes) {
    if(zIndexes) {
      const zIndex = zIndexes.CenterIsland.Stovetop;
      if (this.activeFeature) {
        this.activeFeature.layer.zIndex = zIndex;
      }
    }
  }
}
